import { render, staticRenderFns } from "./ExitFullscreenButton.vue?vue&type=template&id=563933d3&scoped=true&"
import script from "./ExitFullscreenButton.vue?vue&type=script&lang=js&"
export * from "./ExitFullscreenButton.vue?vue&type=script&lang=js&"
import style0 from "./ExitFullscreenButton.vue?vue&type=style&index=0&id=563933d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563933d3",
  null
  
)

export default component.exports